/**
 * package: com.inq.flash.client.chatskins
 * class: PrintMgr
 * root Object
 * @constructor
 */
com.inq.flash.client.chatskins.PrintMgr = function() {
};
$hxClasses['com.inq.flash.client.chatskins.PrintMgr'] = com.inq.flash.client.chatskins.PrintMgr;
/** @private @type {Array} */
com.inq.flash.client.chatskins.PrintMgr.__name__ = ["com","inq","flash","client","chatskins","PrintMgr"];
/** @private @type {com.inq.net.URLLoader} */
com.inq.flash.client.chatskins.PrintMgr.loaderSkin = null;
/** @private @type {string} */
com.inq.flash.client.chatskins.PrintMgr.PRINT_HEADER_ID = "printHeader";
/** @private @type {string} */
com.inq.flash.client.chatskins.PrintMgr.PRINT_HEADER_CLASS_NAME = "print-header";

/**
 * _init
 *
 * $type TFun([],TEnum(Bool,[]))
 * private static function _init():Bool
 * @private
 * @static
 * @return {boolean}
 */
com.inq.flash.client.chatskins.PrintMgr._init = function() {
	/** @type {Window} */
	var win = window;
	return true;
};


/**
 * init
 *
 * $type TFun([],TEnum(Bool,[]))
 * public static function init():Bool
 * @public
 * @static
 * @return {boolean}
 */
com.inq.flash.client.chatskins.PrintMgr.init = function() {

	if(com.inq.flash.client.chatskins.SkinControl.isInApplication("btnPrint")) {
		// Chrome/35 and Chrome/34 misbehave on print requests that can result in browser window death, so we do not allow
		// userAgent: "Mozilla/5.0 (Windows NT 6.1; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/35.0.1916.153 Safari/537.36"
		/** @type {boolean} */
		var badChrome = (/\bChrome\/(34|35)\b/).test(window.navigator.userAgent);
		/** @type {com.inq.ui.Button} */
		var btnPrint = Application.application.getButton("btnPrint");
		if (badChrome) {									/* bad version of Chrome? Then don't attach listener and remove the pointer cursor and tool-tip */
			btnPrint.setStyle("useHandCursor", "false");	/* Turn off the hand cursor (pointer) */
			btnPrint.setStyle("toolTip", "");				/* remove the tool tip */
		} else {
			btnPrint.addEventListener(com.inq.events.MouseEvent.CLICK,com.inq.flash.client.chatskins.PrintMgr.actionBtnPrintTranscript);
			btnPrint.setVisible(true);
		}
	}

	return true;
};


/**
 * actionBtnPrintTranscript
 *
 * $type TFun([{ name => me, t => TInst(com.inq.events.MouseEvent,[]), opt => false }],TEnum(Void,[]))
 * public static function actionBtnPrintTranscript(me:MouseEvent):Void
 * @public
 * @static
 * @param {com.inq.events.MouseEvent}  me
 * @return {void}
 */
com.inq.flash.client.chatskins.PrintMgr.actionBtnPrintTranscript = function(me) {
	com.inq.flash.client.chatskins.PrintMgr.printWindow = window.open("","inqPrint","left=0,top=0,height=600,width=400,status=0,toolbar=0");

	/** @type {string} */
	var transcript = "<table>" + Std.string(com.inq.flash.client.chatskins.PrintMgr.getPrintHeader() +  com.inq.flash.client.chatskins.SkinControl.cw.getHtmlText()) + "</table>";
	/** @type {Array} */
	var links = document.body.parentNode.getElementsByTagName("LINK");
	/** @type {string} */
	var linkUrl = links != null && links.length > 0 && links[0].href;

	if(null != com.inq.flash.client.chatskins.PrintMgr.printWindow) {
		com.inq.flash.client.chatskins.PrintMgr.printWindow.onload = function() {
			return true;
		};

		com.inq.flash.client.chatskins.PrintMgr.printWindow.document.open();
		com.inq.flash.client.chatskins.PrintMgr.printWindow.document.write("<!DOCTYPE html><html><head>" + "<link type=\"text/css\" rel=\"stylesheet\" media=\"print\" href=\"" + linkUrl + "\" />" + "<link type=\"text/css\" rel=\"stylesheet\" media=\"screen\" href=\"" + linkUrl + "\" />" + "</head></html>");

		if (!com.inq.utils.Capabilities.isTablet() && !com.inq.utils.Capabilities.isAndroid()) {
			com.inq.flash.client.chatskins.PrintMgr.printWindow.document.write("<body>" + transcript + "<script>\n setTimeout(\"window.print();window.close();\",1000);\n</script></body>");
		} else {
			/*	RTDEV-27500: The window.close() executes immediately on tablets and does not wait for the print dialog to close as per the design in tablets.
			 	Hence introducing a close button through which the user can manually close the window/tab after closing the print dialog.
			 */
			com.inq.flash.client.chatskins.PrintMgr.printWindow.document.write("<body class='print' onload='printTranscript()'><br/><button onclick='window.close()' style='display: block;margin: 0 auto;padding: 5px'>Close</button></br>" + transcript + 	"<script>\n function printTranscript(){ \n window.print(); \n const isAndroidDevice = navigator.userAgent.toLowerCase().indexOf('android') > -1;\n if(!isAndroidDevice){\n setTimeout(function() {\n   window.close();\n  }, 4000);\n }\n } \n</script></body>");
			/**
			 * RTDEV-14060
			 * Listen to printWindow close event so we can set focus for txtInput box when the print transcript window
			 * is closed.
			 */
			com.inq.flash.client.chatskins.PrintMgr.printWindow.onunload = function (ev) {
				var txtInput = com.inq.flash.client.chatskins.SkinControl.getTextInputField();
				if (com.inq.utils.Capabilities.isIpad()) {
					/**
					 * RTDEV-14060
					 * On IPad, when the Print transcript is closed, IOS will set the focus to the "Site Feedback" button.
					 * If our timeout delay is not long enough, the txtInput.setFocus will be swallowed by the
					 * "SiteFeedback" focus. We can use a very long time delay but that will not be responsive. To work
					 * around the problem, I use a series of setTimeout with shorter time delay. Through experimentation,
					 * I found out that using 3s, 3s, 2s is good enough.
					 */
					window.setTimeout(function () {
						txtInput.setFocus(true);
						window.setTimeout(function() {
							txtInput.setFocus(true);
							window.setTimeout(function() {
								txtInput.setFocus(true);
							}, 3000);
						}, 4000);
					}, 5000);
				} else { // Android tablet.
					window.setTimeout(function () {
						txtInput.setFocus(true);
					}, 50);
				}

			};
		}
		com.inq.flash.client.chatskins.PrintMgr.printWindow.document.close();

	}
};


/**
 * getPrintHeader
 *
 * public static function getPrintHeader()
 * @public
 * @static
 * @return {string}
 */
com.inq.flash.client.chatskins.PrintMgr.getPrintHeader = function() {
	/** @type {com.inq.ui.Canvas} */
	var canvasElement = Application.application.getMxmlItem(com.inq.flash.client.chatskins.PrintMgr.PRINT_HEADER_ID);
	/** @type {string} */
	var header = canvasElement ? "<tr><td class=\"" + com.inq.ui.Container.CLIENT_SPACE_PREFIX + com.inq.flash.client.chatskins.PrintMgr.PRINT_HEADER_CLASS_NAME + "\">" + canvasElement._div.innerHTML + "</td></tr>" : "";

	return header;
};

/** @type {com.inq.flash.client.chatskins.PrintMgr} */
com.inq.flash.client.chatskins.PrintMgr.prototype.__class__ = com.inq.flash.client.chatskins.PrintMgr;

/** @private @type {boolean} */
com.inq.flash.client.chatskins.PrintMgr._initialized = com.inq.flash.client.chatskins.PrintMgr._init();

/** @private @type {null} */
com.inq.flash.client.chatskins.PrintMgr.printWindow = null;

